/**
 * Форматирует номер телефона в формат +7 (999) 999-99-99
 */
export const formatPhone = (value: string): string => {
  // Удаляем все нецифровые символы
  const digits = value.replace(/\D/g, '');
  
  // Если начинается с 8, заменяем на 7
  let formattedDigits = digits;
  if (formattedDigits.startsWith('8')) {
    formattedDigits = '7' + formattedDigits.slice(1);
  }
  
  // Если не начинается с 7, добавляем 7
  if (!formattedDigits.startsWith('7') && formattedDigits.length > 0) {
    formattedDigits = '7' + formattedDigits;
  }
  
  // Ограничиваем до 11 цифр
  formattedDigits = formattedDigits.slice(0, 11);
  
  // Форматируем
  if (formattedDigits.length === 0) {
    return '';
  } else if (formattedDigits.length === 1) {
    return '+7';
  } else if (formattedDigits.length <= 4) {
    return `+7 (${formattedDigits.slice(1)}`;
  } else if (formattedDigits.length <= 7) {
    return `+7 (${formattedDigits.slice(1, 4)}) ${formattedDigits.slice(4)}`;
  } else if (formattedDigits.length <= 9) {
    return `+7 (${formattedDigits.slice(1, 4)}) ${formattedDigits.slice(4, 7)}-${formattedDigits.slice(7)}`;
  } else {
    return `+7 (${formattedDigits.slice(1, 4)}) ${formattedDigits.slice(4, 7)}-${formattedDigits.slice(7, 9)}-${formattedDigits.slice(9, 11)}`;
  }
};

/**
 * Извлекает только цифры из отформатированного номера
 */
export const extractPhoneDigits = (formattedPhone: string): string => {
  return formattedPhone.replace(/\D/g, '');
};

/**
 * Проверяет валидность номера телефона
 */
export const isValidPhone = (phone: string): boolean => {
  const digits = extractPhoneDigits(phone);
  return digits.length === 11 && digits.startsWith('7');
};

/**
 * Преобразует отформатированный номер телефона в число для отправки на бэкенд
 */
export const phoneToNumber = (formattedPhone: string): number => {
  const digits = extractPhoneDigits(formattedPhone);
  return parseInt(digits, 10);
};